(() => {
    
  if (window.__IZ_DYN_DESC_DETAILS_INITED) return;
  window.__IZ_DYN_DESC_DETAILS_INITED = true;

  const __izDynCleanup = {
    intervals: [],
    observers: []
  };

  window.addEventListener("pagehide", () => {
    __izDynCleanup.intervals.forEach((id) => {
      try { clearInterval(id); } catch (_) {}
    });
    __izDynCleanup.intervals = [];

    __izDynCleanup.observers.forEach((obs) => {
      try { obs.disconnect(); } catch (_) {}
    });
    __izDynCleanup.observers = [];
  }, { once: true });

  const LABELS = {
    weight: [
      "weight", "weight:",
      "approx. weight", "approx. weight:",
      'approx. weight (18")', 'approx. weight (18"):',
      'approx. weight (16")', 'approx. weight (16"):',
      'approx. weight (7")', 'approx. weight (7"):',
      "approx weight", "approx weight:",
      'approx weight (18")', 'approx weight (18"):',
      'approx weight (16")', 'approx weight (16"):',
      'approx weight (7")', 'approx weight (7"):'
    ],
    metal: ["metal", "metal:"],
    diameter: ["diameter", "diameter:"],
    chain_length: ["chain length", "chain length:", "length", "length:"],
    diamond_shape: ["diamond shape", "diamond shape:", "shape", "shape:"],
    approx_diamond_dimensions: [
    "approx. diamond dimensions",
    "approx. diamond dimensions:",
    "approx diamond dimensions",
    "approx diamond dimensions:",
    "diamond dimensions",
    "diamond dimensions:",

    "approx. diamond measurement",
    "approx. diamond measurement:",
    "approx diamond measurement",
    "approx diamond measurement:",
    "diamond measurement",
    "diamond measurement:"
  ],

    width: ["width", "width:"],
    chain_width: ["chain width", "chain width:"],
    carat_weight: ["carat weight", "carat weight:", "ct weight", "ct weight:"],
    total_carat_weight: ["total carat weight", "total carat weight:", "total ct weight", "total ct weight:"],
    link_size: ["link size", "link size:"],
    link_dimensions: ["link dimensions", "link dimensions:"],
    dimensions: ["dimensions", "dimensions:"],
    size: ["size", "size:"],
    letter_height: ["letter height", "letter height:"],
    approx_carat_weight_per_letter: [
      "approx. carat weight (per letter)", "approx. carat weight (per letter):",
      "approx carat weight (per letter)", "approx carat weight (per letter):",
      "approx. carat weight per letter", "approx. carat weight per letter:",
      "approx carat weight per letter", "approx carat weight per letter:"
    ],
    approx_total_carat_weight_per_letter: [
      "approx. total carat weight (per letter)", "approx. total carat weight (per letter):",
      "approx total carat weight (per letter)", "approx total carat weight (per letter):",
      "approx. total carat weight per letter", "approx. total carat weight per letter:",
      "approx total carat weight per letter", "approx total carat weight per letter:"
    ],
    gemstones: ["gemstone", "gemstone:", "gemstones", "gemstones:", "gemstone(s)", "gemstone(s):"],
    gemstone: ["gemstone", "gemstone:", "gemstones", "gemstones:", "gemstone(s)", "gemstone(s):"],
    approx_carat_weight: [
      "approx. carat weight", "approx. carat weight:",
      "approx carat weight", "approx carat weight:"
    ],
    approx_total_carat_weight: [
      "approx. total carat weight", "approx. total carat weight:",
      "approx total carat weight", "approx total carat weight:"
    ]

  };

    function normalizeLabel(text) {
      return (text || "")
        .replace(/\u201c|\u201d/g, '"')
        .replace(/\u00a0/g, " ")              
        .replace(/[\u200b-\u200d\ufeff]/g, "") 
        .replace(/\s+:/g, ":")                
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
    }

  function getAllForms() {
    
    return Array.from(document.querySelectorAll("form.js-product-form"));
  }

  function getHost(form) {
    return form ? (form.closest("product-form") || form.closest("[data-section-id]") || document) : document;
  }

  function getProductData(host) {
  const scope = host || document;
  const jsonEl = scope.querySelector('script[data-product-json]');
  if (!jsonEl) return null;

  try {
    return JSON.parse(jsonEl.textContent || "null");
  } catch (_) {
    return null;
  }
}

const IZ_DIAMOND_MM_MAP = {
  "round": {
    "0.25": "4.1mm",
    "0.50": "5.0mm",
    "0.70": "5.6mm",
    "0.75": "5.75mm",
    "0.90": "6.2mm",
    "1.00": "6.5mm",
    "1.25": "6.8mm",
    "1.50": "7.3mm",
    "2.00": "8.0mm",
    "2.50": "8.7mm",
    "3.00": "9.1mm"
  },

  "oval": {
    "0.25": "5.0 x 3.5mm",
    "0.50": "6.0 x 4.0mm",
    "0.70": "7.1 x 4.9mm",
    "0.75": "7.0 x 5.0mm",
    "0.90": "7.5 x 5.5mm",
    "1.00": "7.7 x 5.7mm",
    "1.25": "8.0 x 6.0mm",
    "1.50": "8.5 x 6.5mm",
    "2.00": "9.0 x 7.0mm",
    "2.50": "10.0 x 8.0mm",
    "3.00": "12.0 x 8.0mm"
  },

  "pear": {
    "0.25": "5.0 x 3.5mm",
    "0.50": "6.0 x 4.0mm",
    "0.70": "7.9 x 4.9mm",
    "0.75": "7.0 x 5.0mm",
    "0.90": "8.7 x 5.4mm",
    "1.00": "7.7 x 5.7mm",
    "1.25": "8.0 x 6.0mm",
    "1.50": "8.5 x 6.5mm",
    "2.00": "9.0 x 7.0mm",
    "2.50": "10.0 x 8.0mm",
    "3.00": "12.0 x 8.0mm"
  },

  "heart shaped": {
    "0.25": "4.5 x 4.5mm",
    "0.50": "5.0 x 5.0mm",
    "0.70": "5.7 x 5.7mm",
    "0.75": "6.0 x 6.0mm",
    "0.90": "6.3 x 6.3mm",
    "1.00": "6.5 x 6.5mm",
    "1.25": "7.0 x 7.0mm",
    "1.50": "7.5 x 7.5mm",
    "2.00": "8.0 x 8.0mm",
    "2.50": "8.6 x 8.6mm",
    "3.00": "9.1 x 9.1mm"
  },

  "marquise": {
    "0.25": "6.0 x 3.0mm",
    "0.50": "8.0 x 4.0mm",
    "0.70": "8.7 x 4.3mm",
    "0.75": "9.0 x 4.5mm",
    "0.90": "9.6 x 4.8mm",
    "1.00": "10.0 x 5.0mm",
    "1.25": "11.0 x 5.5mm",
    "1.50": "12.0 x 6.0mm",
    "2.00": "14.0 x 7.0mm",
    "2.50": "15.0 x 7.0mm",
    "3.00": "15.0 x 8.0mm"
  },

  "emerald cut": {
    "0.25": "4.6 x 3.3mm",
    "0.50": "6.0 x 4.0mm",
    "0.70": "6.3 x 4.3mm",
    "0.75": "6.5 x 4.5mm",
    "0.90": "6.8 x 4.8mm",
    "1.00": "7.0 x 5.0mm",
    "1.25": "7.3 x 5.3mm",
    "1.50": "7.5 x 5.5mm",
    "2.00": "9.0 x 7.0mm",
    "2.50": "9.3 x 7.5mm",
    "3.00": "9.75 x 7.7mm"
  },

  "asscher cut": {
    "0.25": "3.8 x 3.8mm",
    "0.50": "4.5 x 4.5mm",
    "0.70": "4.8 x 4.8mm",
    "0.75": "5.0 x 5.0mm",
    "0.90": "5.3 x 5.3mm",
    "1.00": "5.5 x 5.5mm",
    "1.25": "6.0 x 6.0mm",
    "1.50": "6.5 x 6.5mm",
    "2.00": "7.0 x 7.0mm",
    "2.50": "7.5 x 7.5mm",
    "3.00": "8.0 x 8.0mm"
  }
};

function izNormalizeShapeName(shape) {
  const s = (shape || "").toString().trim().toLowerCase();
  if (!s) return "";
  if (s === "heart" || s === "heart shape") return "heart shaped";
  if (s === "emerald" || s === "emerald-cut") return "emerald cut";
  if (s === "asscher" || s === "asscher-cut") return "asscher cut";
  return s;
}

function izParseCaratNumber(val) {
  const s = (val || "").toString().replace(/,/g, ".").trim().toLowerCase();
  const m = s.match(/(\d+(?:\.\d+)?)/);
  if (!m) return null;
  const n = parseFloat(m[1]);
  return Number.isFinite(n) ? n : null;
}


function izToFixedKey(n) {
  return Number(n).toFixed(2); 
}


const _izExactWeightMapByHost = new WeakMap();

function getExactWeightMap(host) {
  const scope = host || document;
  const el = scope.querySelector('script[data-iz-variant-exact-weight]');
  if (!el) return {};

  try {
    return JSON.parse(el.textContent || "{}") || {};
  } catch (_) {
    return {};
  }
}

function getExactWeightForVariantId(host, variantId) {
  if (!variantId) return "";
  const scope = host || document;

  let map = _izExactWeightMapByHost.get(scope);
  if (!map) {
    map = getExactWeightMap(scope);
    _izExactWeightMapByHost.set(scope, map);
  }

  const val = map[String(variantId)];
  return val == null ? "" : val;
}



  function findDescriptionRoot(host) {
    return (
      host.querySelector(".product-description") ||
      host.querySelector('[data-product-description]') ||
      host.querySelector(".product__description") ||
      host.querySelector(".rte") ||
      null
    );
  }

  function findAllValueCellsForLabels(descriptionRoot, labelVariants) {
    if (!descriptionRoot) return [];

    const targets = [];
    const tables = descriptionRoot.querySelectorAll("table");
    for (const table of tables) {
      const rows = table.querySelectorAll("tr");
      for (const row of rows) {
        const cells = row.querySelectorAll("td, th");
        if (cells.length < 2) continue;

        const label = normalizeLabel(cells[0].textContent);
        if (labelVariants.includes(label)) targets.push(cells[1]);
      }
    }
    return targets;
  }

  function getSelectedVariantId(form) {
    const idInput = form.querySelector('input[name="id"]');
    return idInput && idInput.value ? Number(idInput.value) : null;
  }

  function getVariantById(variants, id) {
    if (!variants || !variants.length) return null;
    return variants.find(v => Number(v.id) === Number(id)) || variants[0] || null;
  }

  function getOptionIndex(optionNames, desiredName) {
    const desired = normalizeLabel(desiredName);
    return optionNames.findIndex(name => normalizeLabel(name) === desired);
  }

  function getOptionValueByIndex(variant, idx) {
    if (!variant || idx < 0) return "";
    if (Array.isArray(variant.options) && variant.options[idx]) return variant.options[idx];
    const key = ["option1", "option2", "option3"][idx];
    return key ? (variant[key] || "") : "";
  }

function escapeRegex(s) {
  return (s || "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function looksLikeMappingList(text) {
  const t = (text || "").replace(/\r/g, "").trim();
  if (!t) return false;

  if (t.includes("\n")) return true;

  if (/(small|medium|large|x-large|x-small|mini|standard)\s*[:\-]/i.test(t)) return true;
  if (/\b\d+(\.\d+)?\s*mm\s*[:\-]/i.test(t)) return true;

  return false;
}

function meansSizeMappingList(text) {
  const t = (text || "").replace(/\r/g, "").trim();
  if (!t) return false;

  return /^(small|medium|large|x-large|x-small|mini|standard)\s*(?:-|:)\s*\S+/im.test(t);
}


function formatCaratMulti(value, unit) {
  const s = (value || "").toString().trim();
  if (!s) return "";
  if (/\bctw\b|\bct\b/i.test(s)) return s;

  if (!/\d/.test(s)) return s;
  return `${s} ${unit}`;
}


 function updateCellsFromOptionName({ descriptionRoot, optionNames, variant, labelKeys, optionNameCandidates }) {
  const cells = findAllValueCellsForLabels(descriptionRoot, labelKeys.map(normalizeLabel));
  if (!cells.length) return;

  let idx = -1;
  for (const name of optionNameCandidates) {
    idx = getOptionIndex(optionNames, name);
    if (idx >= 0) break;
  }
  if (idx < 0) return;

  const v = getOptionValueByIndex(variant, idx);
  if (!v) return;

  cells.forEach(cell => {
    const current = (cell.textContent || "").toLowerCase();

    
    if (meansSizeMappingList(cell.textContent || "")) return;

    cell.textContent = v;
  });
}

function updateCellsFromOptionNameFormatted({
  descriptionRoot,
  optionNames,
  variant,
  labelKeys,
  optionNameCandidates,
  formatter
}) {
  const cells = findAllValueCellsForLabels(descriptionRoot, labelKeys.map(normalizeLabel));
  if (!cells.length) return;

  let idx = -1;
  for (const name of optionNameCandidates) {
    idx = getOptionIndex(optionNames, name);
    if (idx >= 0) break;
  }
  if (idx < 0) return;

  const v = getOptionValueByIndex(variant, idx);
  if (v == null || v === "") return;

  cells.forEach(cell => {
    
if (meansSizeMappingList(cell.textContent || "")) return;

    cell.textContent = formatter ? formatter(v) : v;
  });
}


  function extractLinkDimensionForSize(mappingText, selectedSize) {
  const map = (mappingText || "")
    .replace(/\r/g, "")
    .replace(/\u2013|\u2014/g, "-") 
    .trim();    const size = (selectedSize || "").trim();
    if (!map || !size) return "";

    const lines = map
      .split(/\n+/)
      .map(l => l.trim())
      .filter(Boolean);

    const sizeEsc = size.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const reLine = new RegExp("^" + sizeEsc + "\\s*(?:-|:)?\\s*(.+)$", "i");

    for (const line of lines) {
      const m = line.match(reLine);
      if (m && m[1]) return m[1].trim();
    }

    return "";
  }

  function getBestWeightLegacy(variant) {
    if (!variant) return "";
    if (variant.weight != null && variant.weight !== "") return variant.weight;
    if (variant.weight_in_unit != null && variant.weight_in_unit !== "") return variant.weight_in_unit;
    if (variant.grams != null && variant.grams !== "") return variant.grams;
    return "";
  }

  function formatWeight(value) {
    if (value == null) return "";
    if (typeof value === "string") {
      const s = value.trim();
      if (!s) return "";
      return s.toLowerCase().endsWith("g") ? s : `${s}g`;
    }
    if (typeof value === "number") return `${value}g`;
    const s = String(value).trim();
    return s ? (s.toLowerCase().endsWith("g") ? s : `${s}g`) : "";
  }

  function normalizeSizeToken(s) {
    return (s || "").toString().split("(")[0].trim(); 
  }

  function formatCarat(value, unit) {
    let s = (value || "").toString().replace(/\r/g, "").trim();
    if (!s) return "";

    
    s = s
      .replace(/\bcarats?\b/gi, "")   
      .replace(/\bctw?\b/gi, "")     
      .replace(/\s+/g, " ")
      .trim();

    
    
    const numericish = s.match(/[0-9][0-9\s./-]*/);
    const cleaned = (numericish ? numericish[0] : s).trim();

    if (!cleaned) return "";
    return `${cleaned} ${unit}`;
  }



  let IZ_INFO_TAB_WAS_OPENED = false;
  let IZ_ABOUT_TAB_WAS_CLOSED = false;

  function izGetInfoDetails(host) {
    const scope = host || document;
    return scope.querySelector('[data-iz-tab-wrap="info"] details.disclosure') || null;
  }

  function izGetAboutDetails(host) {
    const scope = host || document;
    return scope.querySelector('[data-iz-tab-wrap="about"] details.disclosure') || null;
  }

  function izInitTabPersistence(host) {
    const infoDetails = izGetInfoDetails(host);
    const aboutDetails = izGetAboutDetails(host);

    if (infoDetails && infoDetails.dataset.izTabPersistBound !== "1") {
      infoDetails.dataset.izTabPersistBound = "1";
      infoDetails.addEventListener("toggle", () => {
        IZ_INFO_TAB_WAS_OPENED = !!infoDetails.open;
      });
    }

    if (aboutDetails && aboutDetails.dataset.izTabPersistBound !== "1") {
      aboutDetails.dataset.izTabPersistBound = "1";
      aboutDetails.addEventListener("toggle", () => {
        
        IZ_ABOUT_TAB_WAS_CLOSED = !aboutDetails.open;
      });
    }
  }

  function izRestoreTabState(host) {
    const infoDetails = izGetInfoDetails(host);
    const aboutDetails = izGetAboutDetails(host);

    
    if (infoDetails && IZ_INFO_TAB_WAS_OPENED) {
      infoDetails.open = true;
    }

    
    if (aboutDetails && IZ_ABOUT_TAB_WAS_CLOSED) {
      aboutDetails.open = false;
    }
  }

  function updateForForm(form) {
    const host = getHost(form);
        
    izInitTabPersistence(host);
    const data = getProductData(host);
    if (!data) return;

    const variants = Array.isArray(data.variants) ? data.variants : [];
    const optionNames = Array.isArray(data.options) ? data.options : [];
    if (!variants.length) return;

    const selectedId = getSelectedVariantId(form);
    const variant = getVariantById(variants, selectedId);
    if (!variant) return;

    const descriptionRoot = findDescriptionRoot(host);
    if (!descriptionRoot) return;

    
    const weightCells = findAllValueCellsForLabels(descriptionRoot, LABELS.weight);
    if (weightCells.length) {
      const exact = getExactWeightForVariantId(host, variant && variant.id);
      const legacy = getBestWeightLegacy(variant);
      const best = (exact !== "" && exact != null) ? exact : legacy;
      const w = formatWeight(best);

      
      if (w) {
        weightCells.forEach((cell) => { cell.textContent = w; });
      }
    }

    
    const metalIdx = getOptionIndex(optionNames, "Metal");
    const metalCells = findAllValueCellsForLabels(descriptionRoot, LABELS.metal.map(normalizeLabel));
    if (metalCells.length && metalIdx >= 0) {
      const v = getOptionValueByIndex(variant, metalIdx);
      if (v) metalCells.forEach(cell => { cell.textContent = v; });
    }

    
    const diameterIdx = getOptionIndex(optionNames, "Diameter");
    const diameterCells = findAllValueCellsForLabels(descriptionRoot, LABELS.diameter.map(normalizeLabel));
    if (diameterCells.length && diameterIdx >= 0) {
      const v = getOptionValueByIndex(variant, diameterIdx);
      if (v) diameterCells.forEach(cell => { cell.textContent = v; });
    }

    
    const chainIdx = getOptionIndex(optionNames, "Chain Length");
    const lengthIdx = getOptionIndex(optionNames, "Length");
    const idx = chainIdx >= 0 ? chainIdx : lengthIdx;

    const chainCells = findAllValueCellsForLabels(descriptionRoot, LABELS.chain_length.map(normalizeLabel));
    if (chainCells.length && idx >= 0) {
      const v = getOptionValueByIndex(variant, idx);
      if (v) chainCells.forEach(cell => { cell.textContent = v; });
    }

    
    
    
    updateCellsFromOptionName({
      descriptionRoot,
      optionNames,
      variant,
      labelKeys: LABELS.width,
      optionNameCandidates: ["Width"]
    });

    updateCellsFromOptionName({
      descriptionRoot,
      optionNames,
      variant,
      labelKeys: LABELS.chain_width,
      optionNameCandidates: ["Chain Width", "Width"]
    });

    updateCellsFromOptionName({
    descriptionRoot,
    optionNames,
    variant,
    labelKeys: LABELS.diamond_shape,
    optionNameCandidates: ["Diamond Shape", "Shape"]
    });

    (function updateApproxDiamondDimensions() {
  const cells = findAllValueCellsForLabels(descriptionRoot, LABELS.approx_diamond_dimensions.map(normalizeLabel));
  if (!cells.length) return;

  let shapeIdx = getOptionIndex(optionNames, "Diamond Shape");
  if (shapeIdx < 0) shapeIdx = getOptionIndex(optionNames, "Shape");

  const shapeVal = shapeIdx >= 0 ? getOptionValueByIndex(variant, shapeIdx) : "";
  const shapeKey = izNormalizeShapeName(shapeVal);

  let cwIdx = getOptionIndex(optionNames, "Carat Weight");
  if (cwIdx < 0) cwIdx = getOptionIndex(optionNames, "CT Weight");
  if (cwIdx < 0) cwIdx = getOptionIndex(optionNames, "Ct Weight");

  let caratNum = null;

  if (cwIdx >= 0) {
    caratNum = izParseCaratNumber(getOptionValueByIndex(variant, cwIdx));
  } else {
    
    let tcwIdx = getOptionIndex(optionNames, "Total Carat Weight");
    if (tcwIdx < 0) tcwIdx = getOptionIndex(optionNames, "Total CT Weight");
    if (tcwIdx < 0) tcwIdx = getOptionIndex(optionNames, "Total Ct Weight");

    if (tcwIdx >= 0) {
      const totalNum = izParseCaratNumber(getOptionValueByIndex(variant, tcwIdx));
      
      if (totalNum != null && izToFixedKey(totalNum) === "2.00") {
        caratNum = 1.00;
      } else {
        return; 
      }
    } else {
      return; 
    }
  }

  if (!shapeKey || caratNum == null) return;

  const key = izToFixedKey(caratNum);
  const shapeMap = IZ_DIAMOND_MM_MAP[shapeKey];
  if (!shapeMap || !shapeMap[key]) return;

  const out = shapeMap[key];

  cells.forEach(cell => {
    
    if (meansSizeMappingList(cell.textContent || "")) return;
    cell.textContent = out;
  });
})();


    
    
    updateCellsFromOptionNameFormatted({
      descriptionRoot,
      optionNames,
      variant,
      labelKeys: LABELS.carat_weight,
      optionNameCandidates: [
        "Carat Weight",
        "CT Weight",
        "Ct Weight",
        "Carat",
        "Carats",
        "Diamond Carat",
        "Diamond Size",
        "Stone Size",
        "Center Stone",
        "Center Stone Size"
      ],
      formatter: v => formatCarat(v, "ct")
    });

    
      updateCellsFromOptionNameFormatted({
        descriptionRoot,
        optionNames,
        variant,
        labelKeys: LABELS.total_carat_weight,
        optionNameCandidates: ["Total Carat Weight", "Total CT Weight", "Total Ct Weight"],
        formatter: v => formatCarat(v, "ctw")
      });



    updateCellsFromOptionName({
      descriptionRoot,
      optionNames,
      variant,
      labelKeys: LABELS.gemstones,
      optionNameCandidates: ["Gemstone", "Gemstones", "Gemstone(s)"]
    });

    
    
    

    
    updateCellsFromOptionName({
      descriptionRoot,
      optionNames,
      variant,
      labelKeys: LABELS.link_size,
      optionNameCandidates: ["Link Size"]
    });

    
    (function updateLinkDimensionsRow() {
      const linkSizeIdx = getOptionIndex(optionNames, "Link Size");
      if (linkSizeIdx < 0) return;

      const selectedSize = getOptionValueByIndex(variant, linkSizeIdx);
      if (!selectedSize) return;

      const dimCells = findAllValueCellsForLabels(descriptionRoot, LABELS.link_dimensions.map(normalizeLabel));
      if (!dimCells.length) return;

      dimCells.forEach(cell => {
        
        if (!cell.dataset.izLinkDimsMap) {
          cell.dataset.izLinkDimsMap = (cell.textContent || "").trim();
        }

        const sourceMap = (cell.dataset.izLinkDimsMap || "").trim();
        const dims = extractLinkDimensionForSize(sourceMap, selectedSize);

        
        if (dims) cell.textContent = dims;
      });
    })();

        
    
    
    (function updateSizeMappedRows() {
  let sizeIdx = getOptionIndex(optionNames, "Size");
  if (sizeIdx < 0) sizeIdx = getOptionIndex(optionNames, "Font Size");
  if (sizeIdx < 0) sizeIdx = getOptionIndex(optionNames, "Link Size");
  if (sizeIdx < 0) return;

  const rawSize = getOptionValueByIndex(variant, sizeIdx);
  if (!rawSize) return;

  const selectedSize = normalizeSizeToken(rawSize);
  if (!selectedSize) return;

  function mapRow(labelKeys, cacheKey, formatter) {
    const cells = findAllValueCellsForLabels(descriptionRoot, labelKeys.map(normalizeLabel));
    if (!cells.length) return;

    cells.forEach(cell => {
      if (!cell.dataset[cacheKey]) {
        cell.dataset[cacheKey] = (cell.textContent || "").trim();
      }

      const sourceMap = (cell.dataset[cacheKey] || "").trim();
      const mapped = extractLinkDimensionForSize(sourceMap, selectedSize);

      if (mapped) {
        cell.textContent = formatter ? formatter(mapped) : mapped;
      }
    });
  }

  mapRow(LABELS.dimensions, "izSizeMapDimensions");

  mapRow(LABELS.letter_height, "izSizeMapLetterHeight");

  mapRow(LABELS.diameter, "izSizeMapDiameter");

  mapRow(LABELS.width, "izSizeMapWidth");
  mapRow(LABELS.chain_width, "izSizeMapChainWidth");

  mapRow(LABELS.carat_weight, "izSizeMapCw", v => formatCaratMulti(v, "ct"));
  mapRow(LABELS.total_carat_weight, "izSizeMapTotalCtw", v => formatCaratMulti(v, "ctw"));
  mapRow(LABELS.approx_carat_weight, "izSizeMapApproxCw", v => formatCaratMulti(v, "ct"));
  mapRow(LABELS.approx_total_carat_weight, "izSizeMapApproxTotalCtw", v => formatCaratMulti(v, "ctw"));

  mapRow(LABELS.approx_carat_weight_per_letter, "izSizeMapApproxCtwPerLetter", v => formatCaratMulti(v, "ctw"));
  mapRow(LABELS.approx_total_carat_weight_per_letter, "izSizeMapApproxTotalCtwPerLetter", v => formatCaratMulti(v, "ctw"));
})();
  
  (function updateOptionMappedRows() {
  const optionIdx = getOptionIndex(optionNames, "Option");
  if (optionIdx < 0) return;

  const selectedOption = getOptionValueByIndex(variant, optionIdx);
  if (!selectedOption) return;

  const cells = findAllValueCellsForLabels(descriptionRoot, LABELS.total_carat_weight.map(normalizeLabel));
  if (!cells.length) return;

  cells.forEach(cell => {
    if (!cell.dataset.izOptionMapTotalCtw) {
      cell.dataset.izOptionMapTotalCtw = (cell.textContent || "").trim();
    }

    const sourceMap = (cell.dataset.izOptionMapTotalCtw || "").trim();

    
    
    const lines = sourceMap.replace(/\r/g, "").split(/\n+/).map(l => l.trim()).filter(Boolean);

    const esc = selectedOption.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const re = new RegExp("^" + esc + "\\s*[:\\-]\\s*(.+)$", "i");

    for (const line of lines) {
      const m = line.match(re);
      if (m && m[1]) {
        
        const value = m[1].trim();
        cell.textContent = formatCarat(value, "ctw");
        return;
      }
    }
  });
})();

(function updateDiameterMappedCarats() {
  const diameterIdx = getOptionIndex(optionNames, "Diameter");
  if (diameterIdx < 0) return;

  const selectedDiameter = getOptionValueByIndex(variant, diameterIdx);
  if (!selectedDiameter) return;

  function mapByDiameter(labelKeys, cacheKey, unit) {
    const cells = findAllValueCellsForLabels(descriptionRoot, labelKeys.map(normalizeLabel));
    if (!cells.length) return;

    const re = new RegExp("^" + escapeRegex(selectedDiameter) + "\\s*[:\\-]\\s*(.+)$", "i");

    cells.forEach(cell => {
      if (!cell.dataset[cacheKey]) {
        cell.dataset[cacheKey] = (cell.textContent || "").trim();
      }

      const sourceMap = (cell.dataset[cacheKey] || "").replace(/\r/g, "").trim();
      if (!sourceMap) return;

      const lines = sourceMap.split(/\n+/).map(l => l.trim()).filter(Boolean);
      if (!lines.length) return;

      for (const line of lines) {
        const m = line.match(re);
        if (m && m[1] != null) {
          const value = m[1].trim();
          if (value) cell.textContent = formatCaratMulti(value, unit);
          return;
        }
      }
    });
  }

  mapByDiameter(LABELS.carat_weight, "izDiaMapCw", "ct");
  mapByDiameter(LABELS.total_carat_weight, "izDiaMapTotalCtw", "ctw");
})();

    
  izRestoreTabState(host);
  }

  const pending = new WeakMap();
  function scheduleUpdate(form) {
    if (!form) return;
    if (pending.get(form)) return;
    pending.set(form, true);
    requestAnimationFrame(() => {
      pending.set(form, false);
      updateForForm(form);
    });
  }

  function retryInit(form, tries = 0) {
    const host = getHost(form);
    const root = findDescriptionRoot(host);
    const hasTable = root && root.querySelector("table");
    if (hasTable) {
      scheduleUpdate(form);
      return;
    }
    if (tries >= 40) return; 
    setTimeout(() => retryInit(form, tries + 1), 50);
  }

  function bindForm(form) {
    if (form.dataset.izDynBound === "1") return;
    form.dataset.izDynBound = "1";

    
    retryInit(form);

    
    ["on:variant:change", "variant:change", "variant:changed"].forEach(evt => {
      document.addEventListener(evt, () => scheduleUpdate(form));
    });

    
    form.addEventListener("change", () => scheduleUpdate(form), true);

    
    const idInput = form.querySelector('input[name="id"]');
    if (idInput) {
      
      const obs = new MutationObserver(() => scheduleUpdate(form));
      obs.observe(idInput, { attributes: true, attributeFilter: ["value"] });
       __izDynCleanup.observers.push(obs);


      
      let last = idInput.value;
        const intId = setInterval(() => {
        if (!document.body.contains(form)) return; 
        if (idInput.value !== last) {
          last = idInput.value;
          scheduleUpdate(form);
        }
      }, 200);

      __izDynCleanup.intervals.push(intId);

    }
  }

  function init() {
    getAllForms().forEach(bindForm);

    
    const mo = new MutationObserver(() => {
      getAllForms().forEach(bindForm);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    __izDynCleanup.observers.push(mo);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
